export const UserDeckExample =  ()=>{
    return (
        <div className="container">
            <h2>使い方</h2>
            ユーザーのデッキを示します
        <p>基本的に触らないでください。デバッグ用です</p>
            
        </div>
    )
}